
export const formatNoDecimals = (amount: number | undefined) => {
    if (!amount ) return "";
    return Number(amount).toLocaleString(undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 0
    });
}